import '../../css/App.css';

function Footer() {

    return (
        <div className='footer-bg'>
            <div className='footer-logo-div'>
                <p className='footer-rights'>
                    © 2023 Sneakerama.com, Inc. All Rights Reserved</p>
            </div>
        </div>
    );
}

export default Footer;
